import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';


document.addEventListener('DOMContentLoaded', function() {
    // Check if element exists before initializing Swiper
    const swiperElement = document.querySelector('.systems-swiper');
    if (!swiperElement) {
        return;
    }
    
    const systemsSwiper = new Swiper('.systems-swiper', {
        modules: [Navigation, Pagination, EffectFade],
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 30,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        speed: 800,
        loop: false,
        watchOverflow: false, // Disable automatic overflow detection
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        allowTouchMove: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: 'swiper-button-disabled-custom',
        },
        
        // Ensure images are loaded correctly
        on: {
            init: function() {
                this.update();
                
                // Force navigation update to ensure disabled states are applied
                if (this.navigation) {
                    this.navigation.update();
                }
                
                // Small delay to ensure Swiper is fully initialized
                setTimeout(() => {
                    updateButtonStates();
                    updateSlideCounter();
                }, 100);
            },
            imagesReady: function() {
                this.update();
                
                // Force navigation update after images are loaded
                if (this.navigation) {
                    this.navigation.update();
                }
                
                updateButtonStates();
            },
            slideChange: function() {
                updateButtonStates();
                updateSlideCounter();
            }
        }
    });
    
    // Function to manage button disabled states
    function updateButtonStates() {
        const prevButton = document.querySelector('.swiper-button-prev');
        const nextButton = document.querySelector('.swiper-button-next');
        
        if (prevButton) {
            if (systemsSwiper.activeIndex === 0) {
                prevButton.classList.add('swiper-button-disabled-custom');
            } else {
                prevButton.classList.remove('swiper-button-disabled-custom');
            }
        }
        
        if (nextButton) {
            if (systemsSwiper.activeIndex === systemsSwiper.slides.length - 1) {
                nextButton.classList.add('swiper-button-disabled-custom');
            } else {
                nextButton.classList.remove('swiper-button-disabled-custom');
            }
        }
    }


    // Function to update slide counter
    function updateSlideCounter() {
        const slideCounter = document.querySelector('.--current-slide');
        
        if (slideCounter && systemsSwiper) {
            // Use Swiper activeIndex instead of data-swiper-slide-index
            const activeIndex = systemsSwiper.activeIndex;
            const counterValue = activeIndex + 1; // Convert 0-based to 1-based
            
            slideCounter.textContent = counterValue.toString().padStart(2, '0');
        }
    }
});
